let currentTransactionId = 0;

export const getCurrentTransactionId = () => currentTransactionId;

export const getNewTransactionId = () => {
    currentTransactionId++;
    return currentTransactionId;
};
